import { Helmet } from "react-helmet-async";
import { useLanguage } from "../i18n";

const descriptionMap = {
  sv: "Oxelö Krog är en sjökrog med anor sedan 1600-talet. Sommarcafé med konserter, hemlagad mat och skärgårdsutsikt i Gamla Oxelösund.",
  en: "Oxelö Krog is a historic seaside tavern dating back to the 1600s. Summer café with concerts, homemade food and archipelago views in Old Oxelösund.",
  de: "Oxelö Krog ist eine historische Seekneipe aus dem 17. Jahrhundert. Sommercafé mit Konzerten, hausgemachtem Essen und Schärenblick im alten Oxelösund.",
};

const StructuredData = () => {
  const { lang } = useLanguage();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    name: "Oxelö Krog",
    description: descriptionMap[lang] || descriptionMap.sv,
    url: "https://www.oxelokrog.se",
    telephone: "+46155304 22",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Gamla Oxelösundsvägen 28",
      addressLocality: "Oxelösund",
      postalCode: "613 30",
      addressCountry: "SE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 58.6622473,
      longitude: 17.1278253,
    },
    servesCuisine: "Swedish",
    priceRange: "$$",
    sameAs: [
      "https://www.facebook.com/oxelokrog",
      "https://www.instagram.com/oxelokrog",
    ],
    availableLanguage: [
      { "@type": "Language", name: "Swedish" },
      { "@type": "Language", name: "English" },
      { "@type": "Language", name: "German" },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default StructuredData;
